import axios from 'axios'
import { apiUrl } from '../firebase'

export default {
  get(endpoint, params = {}) {
    return axios.get(`${apiUrl}/${endpoint}`, { params: params })
  },
  create(endpoint, params = {}) {
    return axios.post(`${apiUrl}/${endpoint}`, params)
  },
  update(endpoint, params = {}) {
    return axios.put(`${apiUrl}/${endpoint}`, params)
  },
  delete(endpoint, params = {}) {
    return axios.delete(`${apiUrl}/${endpoint}`, params)
  },
  consult(endpoint, params = {}) {
    return axios.post(`${process.env.VUE_APP_CLOUD_FUNCTION_URL}/${endpoint}`, params)
  }
}
